"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const assert_1 = __importDefault(require("./assert"));
function assertValidUserOptions(options) {
    assert_1.default(Array.isArray(options.domains), 'domains must be an array');
    assert_1.default(Array.isArray(options.topLevelDomains), 'topLevelDomains must be an array');
    assert_1.default(Array.isArray(options.secondLevelDomains), 'secondLevelDomains must be an array');
    assert_1.default(typeof options.distanceFunction === 'function', 'distanceFunction must be a function');
}
exports.default = assertValidUserOptions;
